<div class="modal-header">
  <h5 class="modal-title">{{ 'CAMPAIGN.FILTER_COLUMNS' | translate }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- General Columns Filters -->
  <h6>{{ 'CAMPAIGN.GENERAL_COLUMNS' | translate }}</h6>
  
  <!-- Show/Hide ID Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showID" 
      [(ngModel)]="filters.showID" 
      [class.bg-success]="filters.showID" 
      [class.bg-danger]="!filters.showID">
    <label class="form-check-label" for="showID">{{ 'CAMPAIGN.ID' | translate }}</label>
  </div>

  <!-- Show/Hide Type Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showType" 
      [(ngModel)]="filters.showType" 
      [class.bg-success]="filters.showType" 
      [class.bg-danger]="!filters.showType">
    <label class="form-check-label" for="showType">{{ 'CAMPAIGN.TYPE' | translate }}</label>
  </div>

  <!-- Show/Hide Created Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showCreated" 
      [(ngModel)]="filters.showCreated" 
      [class.bg-success]="filters.showCreated" 
      [class.bg-danger]="!filters.showCreated">
    <label class="form-check-label" for="showCreated">{{ 'CAMPAIGN.CREATED' | translate }}</label>
  </div>

  <!-- Show/Hide Modified Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showModified" 
      [(ngModel)]="filters.showModified" 
      [class.bg-success]="filters.showModified" 
      [class.bg-danger]="!filters.showModified">
    <label class="form-check-label" for="showModified">{{ 'CAMPAIGN.MODIFIED' | translate }}</label>
  </div>

  <!-- Show/Hide Called At Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input
      class="form-check-input w-35px h-20px active-checkbox me-2"
      type="checkbox"
      id="showCalledAt"
      [(ngModel)]="filters.showCalledAt"
      [class.bg-success]="filters.showCalledAt"
      [class.bg-danger]="!filters.showCalledAt">
    <label class="form-check-label" for="showCalledAt">{{ 'CAMPAIGN.CALLED_AT' | translate }}</label>
  </div>

  <!-- Show/Hide Status Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showStatus" 
      [(ngModel)]="filters.showStatus" 
      [class.bg-success]="filters.showStatus" 
      [class.bg-danger]="!filters.showStatus">
    <label class="form-check-label" for="showStatus">{{ 'CAMPAIGN.STATUS' | translate }}</label>
  </div>

  <!-- Show/Hide Phone Number Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showPhone" 
      [(ngModel)]="filters.showPhone" 
      [class.bg-success]="filters.showPhone" 
      [class.bg-danger]="!filters.showPhone">
    <label class="form-check-label" for="showPhone">{{ 'CAMPAIGN.PHONE_NUMBER' | translate }}</label>
  </div>

  <!-- Show/Hide Duration Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showDuration" 
      [(ngModel)]="filters.showDuration" 
      [class.bg-success]="filters.showDuration" 
      [class.bg-danger]="!filters.showDuration">
    <label class="form-check-label" for="showDuration">{{ 'CAMPAIGN.DURATION' | translate }}</label>
  </div>

  <!-- Show/Hide Scheduled Column -->
<div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
  <input 
    class="form-check-input w-35px h-20px active-checkbox me-2" 
    type="checkbox" 
    id="showScheduled" 
    [(ngModel)]="filters.showScheduled" 
    [class.bg-success]="filters.showScheduled" 
    [class.bg-danger]="!filters.showScheduled">
  <label class="form-check-label" for="showScheduled">{{ 'CAMPAIGN.SCHEDULED' | translate }}</label>
</div>


  <!-- Show/Hide Attempts Column -->
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="showAttempts" 
      [(ngModel)]="filters.showAttempts" 
      [class.bg-success]="filters.showAttempts" 
      [class.bg-danger]="!filters.showAttempts">
    <label class="form-check-label" for="showAttempts">{{ 'CAMPAIGN.ATTEMPTS' | translate }}</label>
  </div>

    <!-- Show/Hide Quick Action Column -->
    <div *ngIf="authService.hasRole(['superadmin', 'admin'])" class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="showQuickActions"
        [(ngModel)]="filters.showQuickActions" 
        [class.bg-success]="filters.showQuickActions" 
        [class.bg-danger]="!filters.showQuickActions">
      <label class="form-check-label" for="showQuickActions">{{ 'CAMPAIGN.QUICK_ACTIONS' | translate }}</label>
    </div>

  <!-- Eliot Fields Filters -->
<ng-container *ngIf="campaignModule === 'eliot'" class="mt-5">
  <hr class="mt-5">
  <h6>{{ 'CAMPAIGN.ELIOT_MODULE' | translate }}</h6>
  
  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotID" 
      [(ngModel)]="filters.showEliotID" 
      [class.bg-success]="filters.showEliotID" 
      [class.bg-danger]="!filters.showEliotID">
    <label class="form-check-label" for="eliotID">{{ 'CAMPAIGN.ELIOT_ID' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotName" 
      [(ngModel)]="filters.showEliotName" 
      [class.bg-success]="filters.showEliotName" 
      [class.bg-danger]="!filters.showEliotName">
    <label class="form-check-label" for="eliotName">{{ 'CAMPAIGN.ELIOT_NAME' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotSurname" 
      [(ngModel)]="filters.showEliotSurname" 
      [class.bg-success]="filters.showEliotSurname" 
      [class.bg-danger]="!filters.showEliotSurname">
    <label class="form-check-label" for="eliotSurname">{{ 'CAMPAIGN.ELIOT_SURNAME' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotCompany" 
      [(ngModel)]="filters.showEliotCompany" 
      [class.bg-success]="filters.showEliotCompany" 
      [class.bg-danger]="!filters.showEliotCompany">
    <label class="form-check-label" for="eliotCompany">{{ 'CAMPAIGN.ELIOT_COMPANY' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotLink" 
      [(ngModel)]="filters.showEliotLink" 
      [class.bg-success]="filters.showEliotLink" 
      [class.bg-danger]="!filters.showEliotLink">
    <label class="form-check-label" for="eliotLink">{{ 'CAMPAIGN.ELIOT_PROFILE_LINK' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotSync" 
      [(ngModel)]="filters.showEliotSync" 
      [class.bg-success]="filters.showEliotSync" 
      [class.bg-danger]="!filters.showEliotSync">
    <label class="form-check-label" for="eliotSync">{{ 'CAMPAIGN.ELIOT_SYNC' | translate }}</label>
  </div>

  <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
    <input 
      class="form-check-input w-35px h-20px active-checkbox me-2" 
      type="checkbox" 
      id="eliotSyncDate" 
      [(ngModel)]="filters.showEliotSyncDate" 
      [class.bg-success]="filters.showEliotSyncDate" 
      [class.bg-danger]="!filters.showEliotSyncDate">
    <label class="form-check-label" for="eliotSyncDate">{{ 'CAMPAIGN.ELIOT_SYNC_DATE' | translate }}</label>
  </div>
</ng-container>


  <!-- IntegromatInvent1 Fields Filters -->
  <ng-container *ngIf="campaignModule === 'integromatInvent1'" class="mt-5">
    <hr class="mt-5">
    <h6>{{ 'CAMPAIGN.INVENT_MODULE' | translate }}</h6>
    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactCampaignFrom" 
        [(ngModel)]="filters.showContactCampaignFrom" 
        [class.bg-success]="filters.showContactCampaignFrom" 
        [class.bg-danger]="!filters.showContactCampaignFrom">
      <label class="form-check-label" for="contactCampaignFrom">{{ 'CAMPAIGN.CONTACT_CAMPAIGN_FROM' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactEmail" 
        [(ngModel)]="filters.showContactEmail" 
        [class.bg-success]="filters.showContactEmail" 
        [class.bg-danger]="!filters.showContactEmail">
      <label class="form-check-label" for="contactEmail">{{ 'CAMPAIGN.CONTACT_EMAIL' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactJobFor" 
        [(ngModel)]="filters.showContactJobFor" 
        [class.bg-success]="filters.showContactJobFor" 
        [class.bg-danger]="!filters.showContactJobFor">
      <label class="form-check-label" for="contactJobFor">{{ 'CAMPAIGN.CONTACT_JOB_FOR' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactLanguageGrade" 
        [(ngModel)]="filters.showContactLanguageGrade" 
        [class.bg-success]="filters.showContactLanguageGrade" 
        [class.bg-danger]="!filters.showContactLanguageGrade">
      <label class="form-check-label" for="contactLanguageGrade">{{ 'CAMPAIGN.CONTACT_LANGUAGE_GRADE' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactName" 
        [(ngModel)]="filters.showContactName" 
        [class.bg-success]="filters.showContactName" 
        [class.bg-danger]="!filters.showContactName">
      <label class="form-check-label" for="contactName">{{ 'CAMPAIGN.CONTACT_NAME' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactSource" 
        [(ngModel)]="filters.showContactSource" 
        [class.bg-success]="filters.showContactSource" 
        [class.bg-danger]="!filters.showContactSource">
      <label class="form-check-label" for="contactSource">{{ 'CAMPAIGN.CONTACT_SOURCE' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactSubmit" 
        [(ngModel)]="filters.showContactSubmit" 
        [class.bg-success]="filters.showContactSubmit" 
        [class.bg-danger]="!filters.showContactSubmit">
      <label class="form-check-label" for="contactSubmit">{{ 'CAMPAIGN.CONTACT_SUBMIT' | translate }}</label>
    </div>

    <div class="form-check form-switch form-check-sm form-check-custom form-check-solid mb-3">
      <input 
        class="form-check-input w-35px h-20px active-checkbox me-2" 
        type="checkbox" 
        id="contactSurname" 
        [(ngModel)]="filters.showContactSurname" 
        [class.bg-success]="filters.showContactSurname" 
        [class.bg-danger]="!filters.showContactSurname">
      <label class="form-check-label" for="contactSurname">{{ 'CAMPAIGN.CONTACT_SURNAME' | translate }}</label>
    </div>
  </ng-container>
</div>


<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">{{ 'CAMPAIGN.CANCEL' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="applyFilters()">{{ 'CAMPAIGN.SAVE' | translate }}</button>
</div>